import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const langFiles = import.meta.glob('./lang/*.json', { eager: true })

const resources = Object.entries(langFiles).reduce((curr: any, [path, obj]: any) => {
  const lang: string = path.split('/').pop()?.replace('.json', '') ?? ''
  curr[lang] = {
    translation: obj.default
  }
  return curr
}, {})

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
